<ngx-loading-bar [includeSpinner]="false" color="#dd2610"></ngx-loading-bar>
<dc-session-idle-warning></dc-session-idle-warning>
<router-outlet></router-outlet>
